jQuery(document).ready(function($){
	// Prevent scrolling when mobile menu is open
	$('.navbar-toggler').click( function () {
		$('body').toggleClass('prevent-scroll');
	});


	$(window).resize(function() {
	    window.location.reload();
	});

	if ( $(window).width() <= 768 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  	$('.nav-link').click(function(){
		$("#navbarNavDropdown").removeClass("show");
	  $("button.navbar-toggler").addClass("collapsed");
	  $("button.navbar-toggler").attr("aria-expanded","false");
	});

  } else {

  	//open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	});

  	var rellax = new Rellax('.parallax'); 
  	var rellax = new Rellax('.parallax-slow'); 
  	var rellax = new Rellax('.parallax-fast'); 

		$('.parallax-slow').attr( 'data-rellax-speed', '-7');
		$('.parallax-fast').attr( 'data-rellax-speed', '10');
  }
  document.addEventListener("DOMContentLoaded", function () {
	  const mybutton = document.getElementById("btt");

	  if (mybutton) {
	    // Show/hide on scroll
	    window.addEventListener("scroll", function () {
	      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	        mybutton.style.display = "block";
	      } else {
	        mybutton.style.display = "none";
	      }
	    });

	    // Scroll to top on click
	    mybutton.addEventListener("click", function () {
	      document.body.scrollTop = 0; // For Safari
	      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	    });
	  }
	});


  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);
	});

	$(document).on('facetwp-loaded', function() {
    $('.facetwp-facet-search .facetwp-icon').hide();
    $('.facetwp-facet-search .facetwp-input-wrap').each(function() {
      if ($(this).find('.facetwp-search-submit').length < 1) {
        $(this).find('.facetwp-search').after('<button class="facetwp-search-submit" onclick="FWP.refresh()">Search</button>');
      }
    });
	});

	// Lightbox initialization
	if (typeof GLightbox !== 'undefined') {
		GLightbox({ selector: '.video-lightbox' });
	}

	// Slick slider initialization
	$('.video-slider').each(function () {
		const $slider = $(this);
		const slideCount = $slider.find('.video-slide').length;

		$slider.slick({
			dots: false,
			arrows: slideCount > 1, // disable arrows if only one slide
			prevArrow: $('.slick-prev'),
			nextArrow: $('.slick-next'),
			adaptiveHeight: true
		});
	});


    // Play button overlay handler
    $('.play-button-overlay').on('click', function () {
	    const wrapper = $(this).closest('.video-slide');
	    const video = wrapper.find('video').get(0);

	    if (video) {
	        video.setAttribute('controls', true);
	        video.play();
	    }

	    $(this).fadeOut();
	});


	// Pause videos and show overlays when slide changes
	$('.video-slider').on('beforeChange', function () {
	    $('.video-player').each(function () {
	        this.pause();
	        this.removeAttribute('controls');
	        this.currentTime = 0;
	    });
	    $('.play-button-overlay').fadeIn();
	});

	// Click poster to play and hide overlay
	$('.video-slide video').on('play', function () {
		$(this).siblings('.play-button-overlay').fadeOut();
	});

});

document.addEventListener("DOMContentLoaded", function(event) {

	window.addEventListener("load", function(e) {
    
    gsap.registerPlugin(ScrollTrigger);

  	gsap.to('.fadeUp', {
  		duration: 1,
  		stagger: 0.5,
			opacity: 1,
			y: -10,
			ease: "back.out(1.7)",
			scrollTrigger: {
				start: 'top 75%',
				trigger: '.fadeUp'
			}
		});

		gsap.to('.drop-trigger', {
			y: 0,
			scrollTrigger: {
				scrub: 2,
				start: 'top 75%',
				trigger: '.drop-trigger'
			}
		});

		gsap.to('.home-resources::before', {
			y: 0,
			scrollTrigger: {
				scrub: 2,
				start: 'top 75%',
				trigger: '.home-resources::before'
			}
		});

		gsap.from('.drop-right', {
			y: 0,
			scrollTrigger: {
				scrub: 2,
				start: 'top top',
				trigger: '.drop-right'
			}
		});

		gsap.to('.drop-left', {
			y: 0,
			scrollTrigger: {
				scrub: 2,
				start: '-=100 25%',
				end: 'center',
				trigger: '.drop-left'
			}
		});

  });

});

function initFacetToggleHeaders() {
	document.querySelectorAll('.facet-toggle__header').forEach((btn) => {
		if (btn.dataset.toggleInit === 'true') {
			return;
		}

		btn.dataset.toggleInit = 'true';

		btn.addEventListener('click', () => {
			const wrapper = btn.closest('.facet-toggle');

			if (!wrapper) {
				return;
			}

			wrapper.classList.toggle('is-open');
			btn.classList.toggle('is-open');

			const expanded = btn.getAttribute('aria-expanded') === 'true';
			btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
		});
	});
}

function initSortingCheckboxUI() {
	document.querySelectorAll('.sorting-checkbox-ui').forEach((ui) => {
		const facetName = ui.dataset.facet || 'sorting';
		const facetWrapper = document.querySelector('.facetwp-facet-' + facetName);

		if (!facetWrapper) {
			return;
		}

		const select = facetWrapper.querySelector('select');

		if (!select) {
			return;
		}

		const buttons = ui.querySelectorAll('.sorting-checkbox-ui__option');

		function syncActiveState() {
			let currentValue = select.value;

			// If nothing is selected, treat Latest as default visually
			if (!currentValue) {
				currentValue = 'latest';
			}

			buttons.forEach((button) => {
				button.classList.toggle('is-active', button.dataset.value === currentValue);
			});
		}

		if (ui.dataset.sortingInit !== 'true') {
			ui.dataset.sortingInit = 'true';

			buttons.forEach((button) => {
				button.addEventListener('click', () => {
					const value = button.dataset.value;

					if (!value) {
						return;
					}

					if (select.value === value) {
						syncActiveState();
						return;
					}

					select.value = value;
					select.dispatchEvent(new Event('change', { bubbles: true }));
					syncActiveState();
				});
			});
		}

		syncActiveState();
	});
}

function initFacetCustomUI() {
	initFacetToggleHeaders();
	initSortingCheckboxUI();
}

document.addEventListener('DOMContentLoaded', initFacetCustomUI);
document.addEventListener('facetwp-loaded', initFacetCustomUI);